import { useEffect, useState } from "react";
import { useNavigate, useSearch } from "@tanstack/react-router";
import { api, errorMessage } from "@/lib/api";
import { endpoints } from "@/lib/endpoints";
import { queryClient } from "@/lib/queryClient";
import { queryKeys } from "@/lib/queryKeys";
import { usePreviewModeStore } from "./mode";

/*
 * Where the Plan's iframe lands: swap the one-time code for the preview
 * cookie, mark this frame as a preview, and open the staff app as that
 * person sees it.
 */
export function StaffPreviewEntry() {
  const { code } = useSearch({ from: "/staff/preview" });
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!code) return;
    usePreviewModeStore.getState().set(true);
    api(endpoints.staffAuth.preview, { method: "POST", body: { code }, quiet401: true })
      .then(async () => {
        queryClient.removeQueries({ queryKey: queryKeys.staff.all });
        await navigate({ to: "/staff", replace: true });
      })
      .catch((e: unknown) => setError(errorMessage(e)));
  }, [code, navigate]);

  return (
    <div className="flex min-h-dvh items-center justify-center bg-canvas p-6 text-center text-[15px] text-muted">{!code ? "This preview has ended. Reload it from the Plan." : (error ?? "Opening…")}</div>
  );
}
